/* eslint-disable react/no-danger */
import React, { useEffect, useRef } from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { GridContainer } from './styles';

function Grid({ children, columns }) {
  const childEls = Array.isArray(children) ? children : [children];
  const gridRef = useRef(null);

  useEffect(() => {
    if (gridRef.current) {
      const body = gridRef.current.getElementsByClassName('grid_body')[0];
      const header = gridRef.current.getElementsByClassName('grid_header')[0];
      if (body && header) {
        if (body.scrollHeight > 350) {
          header.classList.add('grid__scrolling');
        } else {
          header.classList.remove('grid__scrolling');
        }
      }
    }
  });
  return (
    <GridContainer ref={gridRef}>
      {childEls
        .filter((x) => React.isValidElement(x))
        .map((x, i) =>
          React.cloneElement(x, {
            // eslint-disable-next-line react/no-array-index-key
            key: `grid-child_${i}`,
            columns,
            ...(x.props || {}),
          })
        )}
    </GridContainer>
  );
}

Grid.defaultProps = {
  children: [],
};

Grid.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  columns: string.isRequired,
};

function GridFallback() {
  return <GridContainer />;
}

export default exportWithBoundary(Grid, GridFallback);
